<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-03-10 10:26:53
 * @FilePath: \qctsw-vue\packages\app\src\pages\complaint\components\RelativeCollective.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'

const props = withDefaults(defineProps<{
  brandList?: { brandId: number, brandName: string }[]
  seriesList?: {
    brandId: number
    brandName: string
    seriesId: number
    seriesName: string
  }[]
  complainExplain?: string
  measure?: string
  newestResult: {
    newestResultExplain?: string
    collectiveResultScoreCode?: string
  }
}>(), {
  brandList: () => [],
  seriesList: () => [],
  complainExplain: '',
  measure: '',
})
</script>

<template>
  <div class="rounded-1.5 border-1 border-slate-2 mt-xl">
    <div class="flex items-center justify-between font-bold bg-slate-2 px-4 h-11">
      <slot name="title">
        <div>集体投诉信息</div>
      </slot>
    </div>
    <div class="px-4 ">
      <div v-if="props.brandList && props.brandList.length" class="flex items-start overflow-hidden py-3  border-b-1 border-slate-2">
        <div class="flex-shrink-0 w-25 text-right mr-sm text-slate-4">
          涉及品牌:
        </div>
        <NuxtLink
          v-for="(v, i) in brandList" :key="i"
          :to="APP_ROUTER.complaintSearch({ carBrandId: v.brandId, carBrandName: v.brandName })"
          class="mr-2.5 leading-1.5em overflow-hidden hover:text-blue-5"
        >
          {{ v.brandName }}
        </NuxtLink>
      </div>
      <div
        v-if="props.seriesList && props.seriesList.length"
        class="flex items-start overflow-hidden py-3  border-b-1 border-slate-2"
      >
        <div class="flex-shrink-0 w-25 text-right mr-sm text-slate-4">
          涉及车系:
        </div>
        <div class="flex flex-wrap">
          <NuxtLink
            v-for="(v, i) in props.seriesList" :key="i" target="_blank"
            :to="`/complaint/search?carBrandId=${v.brandId}&seriesId=${v.seriesId}&carBrandName=${v.brandName}&carSeriesName=${v.seriesName}`"
            class="mr-2.5 leading-1.5em overflow-hidden primary-hover"
          >
            {{ v.seriesName }}{{ i !== props.seriesList.length - 1 ? '、' : '' }}
          </NuxtLink>
        </div>
      </div>
      <div v-if="props.complainExplain" class="flex items-start overflow-hidden py-3">
        <div class="flex-shrink-0 w-25 text-right  mr-sm text-slate-4">
          说明:
        </div>
        <div class="flex-grow min-w-0 leading-1.5em overflow-hidden">
          {{ props.complainExplain }}
        </div>
      </div>
    </div>
    <div v-if="props.measure" class="bg-slate-1 mx-4 mb-4 rounded-1.5 overflow-hidden p-4">
      <div class="font-bold mb-3">
        企业当前措施:
      </div>
      <div class="leading-1.5em">
        {{ props.measure }}
      </div>
    </div>

    <div v-if="props.newestResult?.newestResultExplain" class="bg-slate-1 mx-4 mb-4 rounded-1.5 overflow-hidden p-4">
      <div class="font-bold mb-3">
        企业最新结果:
      </div>
      <div class="leading-1.5em">
        {{ props.newestResult.newestResultExplain }}
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>

</style>
